"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UIContextProvider = exports.useUIContextProviderProps = exports.useUIContext = void 0;
var tslib_1 = require("tslib");
var UI_1 = require("@reactionable/core/lib/ui/UI");
var react_1 = tslib_1.__importDefault(require("react"));
var ErrorAlert_1 = require("./alert/ErrorAlert");
var WarningAlert_1 = require("./alert/WarningAlert");
var Confirmation_1 = require("./confirmation/Confirmation");
var Form_1 = require("./form/Form");
var Layout_1 = require("./layout/Layout");
var Loader_1 = require("./loader/Loader");
var Modal_1 = require("./modal/Modal");
var ModalForm_1 = require("./modal/ModalForm");
var ErrorNotification_1 = require("./notification/ErrorNotification");
var SuccessNotification_1 = require("./notification/SuccessNotification");
function useUIContext() {
    return UI_1.useUIContext();
}
exports.useUIContext = useUIContext;
function useUIContextProviderProps() {
    return {
        useLoader: Loader_1.useLoader,
        useSuccessNotification: SuccessNotification_1.useSuccessNotification,
        useErrorNotification: ErrorNotification_1.useErrorNotification,
        useErrorAlert: ErrorAlert_1.useErrorAlert,
        useWarningAlert: WarningAlert_1.useWarningAlert,
        useConfirmation: Confirmation_1.useConfirmation,
        useLayout: Layout_1.useLayout,
        useForm: Form_1.useForm,
        useModal: Modal_1.useModal,
        useModalForm: ModalForm_1.useModalForm,
    };
}
exports.useUIContextProviderProps = useUIContextProviderProps;
exports.UIContextProvider = function (props) {
    return react_1.default.createElement(UI_1.UIContextProvider, tslib_1.__assign({}, useUIContextProviderProps(), props));
};
//# sourceMappingURL=UI.js.map